import { render } from "./ProfileForm.vue?vue&type=template&id=8ca710f8"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=8ca710f8&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script